module.exports = __webpack_public_path__ + "img/module2_item3.99a11328.png";